import * as React from "react";
import {
    Button,
    FormGroup,
    Grid,
    Switch,
    TextField,
    FormControlLabel
} from "@material-ui/core";
import {API} from "aws-amplify";
import {Alert} from "@material-ui/lab";
import {LoadingSpinner} from "../../../../utils/LoadingSpinner";
import {
    updatePrescriptionRequestDefault,
    IUpdatePrescriptionRequest
} from "./request/UpdatePrescriptionRequest";
import JsonRenderComponent from "../../../../utils/JsonRenderComponent";
import { AMAZON_ID } from "../../../../consts/Patterns";

interface IProps {
    data?: any
}

interface IState {
    errorMessage: string,
    isJsonInput: boolean,
    isLoading: boolean,
    jsonInput: string,
    request: IUpdatePrescriptionRequest,
    response: any
}

enum InputField {
    DRUG_ID,
    RX_NUMBER,
    PERSON_ID,
    PRESCRIPTION_ID,
    PROFILE_ID,
    DAYS_SUPPLY,
    DAYS_SUPPLY_PER_FILL,
    DISPENSE_DAYS_SUPPLY,
    DISPENSE_QUANTITY,
    AUTHORIZED_QUANTITY_PERFILL,
    AUTHORIZED_TOTAL_QUANTITY,
    EXPIRATION_DATE
}

class UpdatePrescriptionSection extends React.Component<IProps, IState> {
    private isValidation: boolean;
    constructor(props: IProps) {
        super(props);
        this.state = {
            errorMessage: '',
            isJsonInput: false,
            isLoading: false,
            jsonInput: updatePrescriptionRequestDefault,
            request: { personId: '' } as IUpdatePrescriptionRequest,
            response: ''
        };

        this.toggleJsonInput = this.toggleJsonInput.bind(this);
        this.setRequest = this.setRequest.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    public render() {
        return(
            <Grid
                container
                direction="column"
                justify="center"
                alignItems="center"
                spacing={3}
            >
                <Grid item xs>
                    <FormGroup>
                        <FormControlLabel control={ <Switch onChange={ this.toggleJsonInput }/> } label="Toggle Json Input" />
                    </FormGroup>
                </Grid>

                { !this.state.isJsonInput &&
                    <Grid
                        container
                        direction="column"
                        justify="center"
                        alignItems="center"
                        spacing={3}
                    >
                        <Grid item xs>
                            <TextField
                                style={{width: 400}}
                                label="Drug Id (Required)"
                                variant="outlined"
                                value={ this.state.request.drugId || '' }
                                onChange={ (event: React.ChangeEvent<HTMLTextAreaElement>) => this.setRequestFields(InputField.DRUG_ID, event) }
                            />
                        </Grid>
                        <Grid item xs>
                            <TextField
                                style={{width: 400}}
                                label="Person Id (Required)"
                                variant="outlined"
                                value={ this.state.request.personId || '' }
                                onChange={ (event: React.ChangeEvent<HTMLTextAreaElement>) => this.setRequestFields(InputField.PERSON_ID, event) }
                            />
                        </Grid>
                        <Grid item xs>
                            <TextField
                                style={{width: 400}}
                                label="Prescription Id (Required)"
                                variant="outlined"
                                value={ this.state.request.prescriptionId || '' }
                                onChange={ (event: React.ChangeEvent<HTMLTextAreaElement>) => this.setRequestFields(InputField.PRESCRIPTION_ID, event) }
                            />
                        </Grid>
                        <Grid item xs>
                            <TextField
                                style={{width: 400}}
                                label="Profile Id (Required)"
                                variant="outlined"
                                value={ this.state.request.profileId || '' }
                                onChange={ (event: React.ChangeEvent<HTMLTextAreaElement>) => this.setRequestFields(InputField.PROFILE_ID, event) }
                            />
                        </Grid>
                        <Grid item xs>
                            <TextField
                                style={{width: 400}}
                                label="RxNumber (Required)"
                                variant="outlined"
                                value={ this.state.request.rxNumber || '' }
                                onChange={ (event: React.ChangeEvent<HTMLTextAreaElement>) => this.setRequestFields(InputField.RX_NUMBER, event) }
                            />
                        </Grid>
                        <Grid item xs>
                            <TextField
                                style={{width: 400}}
                                label="Days Supply (Required)"
                                variant="outlined"
                                value={ this.state.request.daysSupply || '' }
                                onChange={ (event: React.ChangeEvent<HTMLTextAreaElement>) => this.setRequestFields(InputField.DAYS_SUPPLY, event) }
                            />
                        </Grid>
                        <Grid item xs>
                            <TextField
                                style={{width: 400}}
                                label="Days Supply Per Fill (Required)"
                                variant="outlined"
                                value={ this.state.request.daysSupplyPerFill || '' }
                                onChange={ (event: React.ChangeEvent<HTMLTextAreaElement>) => this.setRequestFields(InputField.DAYS_SUPPLY_PER_FILL, event) }
                            />
                        </Grid>
                        <Grid item xs>
                            <TextField
                                style={{width: 400}}
                                label="Dispense Days Supply (Required)"
                                variant="outlined"
                                value={ this.state.request.dispenseDaysSupply || '' }
                                onChange={ (event: React.ChangeEvent<HTMLTextAreaElement>) => this.setRequestFields(InputField.DISPENSE_DAYS_SUPPLY, event) }
                            />
                        </Grid>
                        <Grid item xs>
                            <TextField
                                style={{width: 400}}
                                label="Dispense Quantity (Required)"
                                variant="outlined"
                                value={ this.state.request.dispenseQuantity || '' }
                                onChange={ (event: React.ChangeEvent<HTMLTextAreaElement>) => this.setRequestFields(InputField.DISPENSE_QUANTITY, event) }
                            />
                        </Grid>
                        <Grid item xs>
                            <TextField
                                style={{width: 400}}
                                label="Authorized Total Quantity (Required)"
                                variant="outlined"
                                value={ this.state.request.authorizedTotalQuantity || '' }
                                onChange={ (event: React.ChangeEvent<HTMLTextAreaElement>) => this.setRequestFields(InputField.AUTHORIZED_TOTAL_QUANTITY, event) }
                            />
                        </Grid>
                        <Grid item xs>
                            <TextField
                                style={{width: 400}}
                                label="Authorized Quantity Per Fill (Required)"
                                variant="outlined"
                                value={ this.state.request.authorizedQuantityPerFill || '' }
                                onChange={ (event: React.ChangeEvent<HTMLTextAreaElement>) => this.setRequestFields(InputField.AUTHORIZED_QUANTITY_PERFILL, event) }
                            />
                        </Grid>
                        <Grid item xs>
                            <TextField
                                style={{width: 400}}
                                label="Expiration Date (Optional)"
                                variant="outlined"
                                value={ this.state.request.expirationDate || '' }
                                onChange={ (event: React.ChangeEvent<HTMLTextAreaElement>) => this.setRequestFields(InputField.EXPIRATION_DATE, event) }
                            />
                        </Grid>
                    </Grid>
                }

                { this.state.isJsonInput &&
                    <Grid item xs>
                        <TextField
                            multiline
                            rows={ 13 }
                            label="Update Prescription Request"
                            variant="filled"
                            value={ this.state.jsonInput }
                            onChange={ this.setRequest }
                            style={{ width: 800 }}
                        />
                    </Grid>
                }

                <Grid item xs>
                    <Button variant="outlined" color="default" onClick={ this.handleSubmit }>
                        Update Prescription
                    </Button>
                </Grid>

                { this.state.isLoading && <LoadingSpinner/> }

                { this.state.errorMessage &&
                    <Alert variant="filled" severity="info">
                        Error encountered: { this.state.errorMessage }
                    </Alert>
                }

                { this.state.response &&
                    <div>
                        <br/>
                        <h4>Status</h4>
                        <p style={{
                            border: '3px solid lightgray',
                            padding: '5px',
                            whiteSpace: "pre-wrap",
                            wordBreak: "normal",
                            wordWrap: "break-word"
                        }}>
                            <JsonRenderComponent jsonObject={ this.state.response } printHtml={ false }/>
                        </p>
                    </div>
                }
            </Grid>
        );
    }

    private toggleJsonInput() {
        this.setState({ isJsonInput: !this.state.isJsonInput });
    }

    private handleValidation(request : IUpdatePrescriptionRequest) {
        let formIsValid = true;
        if (!request.personId) {
            alert('Please enter the person id');
            formIsValid = false
        } else if (!request.personId.match(AMAZON_ID)) {
            alert('Please enter the valid person id.');
            formIsValid = false
        }
        if (!request.profileId) {
            alert('Please enter the profile id');
            formIsValid = false
        } else if (!request.profileId.match(AMAZON_ID)) {
            alert('Please enter the valid profile id.');
            formIsValid = false
        }
        if (!request.prescriptionId) {
            alert('Please enter the prescription Id');
            formIsValid = false
        } else if (!request.prescriptionId.match("^[A-Za-z0-9]{24}$")) {
            alert('Please enter the valid prescription id.');
            formIsValid = false
        }
        if (!request.drugId) {
            alert('Please enter the drug Id');
            formIsValid = false
        } else if (!request.drugId.match("^[A-Za-z0-9]{24}$")) {
            alert('Please enter the valid drug id.');
            formIsValid = false
        }
        if (!request.rxNumber) {
            alert('Please enter the rxNumber');
            formIsValid = false
        } else if (!request.rxNumber.match("^[0-9]{10}$")) {
            alert('Please enter the valid rxNumber.');
            formIsValid = false
        }
        if (request.expirationDate) {
            if (!request.expirationDate.match("^\\d{4}\\-(0[1-9]|1[012])\\-(0[1-9]|[12][0-9]|3[01])$")) {
                alert('Date should follow format yyyy-mm-dd');
                formIsValid = false
            }
        }
        if (!request.dispenseDaysSupply || !request.dispenseQuantity || !request.daysSupply
            || !request.daysSupplyPerFill || !request.authorizedQuantityPerFill || !request.authorizedTotalQuantity ) {
            alert('Please enter all the mandatory params DispenseDaysSupply, DispenseQuantity, DaysSupply, ' +
                'AuthorizedTotalQuantity, AuthorizedQuantityPerFill, DaysSupplyPerFill');
            formIsValid = false
        }
        return formIsValid;
    }

    private setFields(request : IUpdatePrescriptionRequest, event : React.ChangeEvent<HTMLTextAreaElement>, field: InputField) {
        if (field === InputField.DRUG_ID) { request.drugId = event.target.value; }
        if (field === InputField.RX_NUMBER) { request.rxNumber = event.target.value; }
        if (field === InputField.PRESCRIPTION_ID) { request.prescriptionId = event.target.value; }
        if (field === InputField.PROFILE_ID) { request.profileId = event.target.value; }
        if (field === InputField.DAYS_SUPPLY) { request.daysSupply = event.target.value; }
        if (field === InputField.DAYS_SUPPLY_PER_FILL) { request.daysSupplyPerFill = event.target.value; }
        if (field === InputField.AUTHORIZED_QUANTITY_PERFILL) { request.authorizedQuantityPerFill = event.target.value; }
        if (field === InputField.AUTHORIZED_TOTAL_QUANTITY) { request.authorizedTotalQuantity = event.target.value; }
        if (field === InputField.PERSON_ID) { request.personId = event.target.value; }
        if (field === InputField.DISPENSE_QUANTITY) { request.dispenseQuantity = event.target.value; }
        if (field === InputField.DISPENSE_DAYS_SUPPLY) { request.dispenseDaysSupply = event.target.value; }
        if (field === InputField.EXPIRATION_DATE) { request.expirationDate = event.target.value; }
        this.setRequestState(request)
    }

    private setRequestFields(field: InputField, event: React.ChangeEvent<HTMLTextAreaElement>) {
        const updatedRequest: IUpdatePrescriptionRequest = this.state.request;
        this.setFields(updatedRequest, event, field);
    }

    private setRequestState(updatedRequest : IUpdatePrescriptionRequest) {
        this.setState({ request: updatedRequest });
        console.log(this.state.request);
    }

    private setRequest(event: React.ChangeEvent<HTMLTextAreaElement>) {
        this.setState({ jsonInput: event.target.value });
    }

    private handleSubmit() {
        this.setState({isLoading: true});
        this.setState({errorMessage: ''});
        let body: IUpdatePrescriptionRequest;

        if (this.state.isJsonInput) {
            body = JSON.parse(this.state.jsonInput);
            this.isValidation = this.handleValidation(body);
        } else {
            body = this.state.request;
            this.isValidation =  this.handleValidation(body);
        }

        if (this.isValidation) {
            const config = {
                body,
                headers: {}
            }
            this.callUpdatePrescription(config);
        }
        this.setState({isLoading: false});
    }

    private callUpdatePrescription(config: any) {
        const apiName = 'ApaqPortalAPI';
        const path = '/prescription/update-prescription';

        console.log(config)
        API.post(apiName, path, config).then((updatePrescriptionResponse: any) => {
            console.log(updatePrescriptionResponse);
            this.setState({ response: updatePrescriptionResponse });
        }).catch((error) => {
            console.log(error);
            this.setState({ errorMessage: error.response.data.message });
        });
    }
}

export default UpdatePrescriptionSection;
